import styled from '@emotion/styled/macro'
import { Box } from 'grid'
import { themeColor, themeFont } from 'mixins'
import {
  IFontStyles,
  IPalette,
  Text as FabricText,
} from 'office-ui-fabric-react'

export interface TextProps {
  font?: keyof IFontStyles
  color?: keyof IPalette
}

export const Text = styled(Box)`
  ${({ font: themeFontName }: TextProps) =>
    themeFontName ? themeFont(themeFontName) : ''};
  color: ${({ color }: TextProps) => (color ? themeColor(color) : 'inherit')};
`

// TODO: refactor
export const Text2 = styled(FabricText)`
  color: ${({ color }: { color?: keyof IPalette }) =>
    color ? themeColor(color) : 'inherit'};
`
